<div class="container mt-5 mb-5 d-flex align-items-center justify-content-between header">
    <div class="logo"><img src="../../../assets/img/logo.svg" /></div>
    <div class="d-flex justify-content-start align-items-center menu">
        <a>Hakkımızda</a>
        <a>Projelerimiz</a>
        <a>Sponsorlarımız</a>
        <a>İletişim</a>
    </div>
    <div class="d-flex align-items-center justify-content-between demo-request">
        <a href="https://teams.live.com/l/invite/FEAU62vq7O4S4BJ_gE">Demo Talep Et</a>
        <svg width="22" height="16" viewBox="0 0 22 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 15L21 8L15 1" stroke="#9C69E2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        <path d="M21 8H1" stroke="#9C69E2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
    </div>
</div>